export default {
    guest: {
        changeLanguage: 'English',
        forgotPassword: 'Забыли пароль?',
        toLogin: 'Войти',
        toLoginSSO: 'Войти через SSO',
        email: 'Email',
        login: 'Логин',
        password: 'Пароль',
        recoveryPage: 'Восстановление пароля',
        recovery: 'Отправить',
        reset: 'Отправить',
        invalidResetToken: 'Недействительная ссылка на восстановление пароля',
        captchaRefresh: 'Обновить изображение',
        captcha: 'Введите код с картинки',
        OfficeWasCreated: 'Личный кабинет успешно создан',
        invalidAuthToken: 'Недействительная ссылка для регистрации',
        passwordResetSuccess: 'На Ваш персональный почтовый ящик отправлено сообщение. Перейдите по ссылке в сообщении и следуйте дальнейшим инструкциям для изменения пароля.',
    }
};
